/**
 * Format a numeric value for display, stripping binary floating-point
 * artifacts such as `8.300000000000001` (which should read `8.3`).
 *
 * Values can arrive as a Prisma `Decimal`, a `number`, or a `string`. We
 * normalize through `Number` and re-parse at 15 significant digits — the
 * precision at which IEEE-754 doubles round-trip cleanly — so genuine
 * precision is preserved while representation noise is removed.
 *
 * The final `.toString()` re-normalizes the result, so output matches native
 * `Number.prototype.toString` for every magnitude (the scientific notation
 * `toPrecision` introduces for very large/small values is collapsed back for
 * anything in `[1e-6, 1e21)`, and only appears where `toString` would use it
 * anyway). Non-finite values (`NaN`, `Infinity`) fall back to their raw string.
 */
export function formatDecimalDisplay(
  value: number | string | { toString(): string },
): string {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return value.toString();
  }
  return Number.parseFloat(num.toPrecision(15)).toString();
}
